@use "../../styles/breakpoint.module.scss" as *;

.article {
    position: relative;
    text-align: left;
}

.image {
    display: block;
    width: 100%;
    aspect-ratio: 1;
}

.badge {
    --height: 25px;
    --background-color: var(--ice-blue);
    --offset: 16px;

    composes: fontEyebrow14 from "../../styles/composable/typography.module.css";
    position: absolute;
    top: var(--offset);
    left: var(--offset);
    height: var(--height);

    // specificity nonsense
    .article & {
        line-height: var(--height);
    }

    @media ($below-mobile) {
        --offset: 8px;
    }

    &::before,
    &::after {
        content: "";
        display: inline-block;
        clip-path: path(
            "M12.97 25 13 .03.69 0C.2 0-.13.56.05 1.07l3.13 8.66a8.22 8.22 0 0 1 0 5.57L.05 23.94C-.13 24.44.2 25 .7 25Z"
        );
        background-color: var(--background-color);
        width: 13px;
        height: 100%;
        vertical-align: top;
    }

    &::after {
        transform: scaleX(-1);
    }

    span {
        display: inline-block;
        height: 100%;
        background-color: var(--background-color);
    }
}

.title {
    margin-top: var(--spacer-16);
    font: var(--font-h-24);
}

.placeholder {
    display: flex;
    place-content: center;
    background-color: var(--true-white);
    width: 100%;
    aspect-ratio: 1;

    svg {
        width: 24%;
        color: var(--pale-navy);
    }
}
